import { IMatrix4, IVector3 } from '../../../../api.js';
import { assert } from '../../../../babylon/utility/Assert.js';
import { GIZMO_AXIS_COLOR, GIZMO_COLOR_FACTOR } from '../GizmoColors.js';
import { MeshDescriptions } from '../MeshDescriptions.js';
export class MovePlane {
    constructor(viewer, transform_handling, use_global_transform, plane) {
        this.transform_handling = transform_handling;
        this.use_global_transform = use_global_transform;
        this.plane = plane;
        this._viewer = viewer;
        const color = GIZMO_AXIS_COLOR[plane];
        const arrow_mesh_description = MeshDescriptions.create_plane(0.2, // width
        0.2, // height
        color // color
        );
        this._ui_mesh = this._viewer.create_ui_mesh();
        this._ui_mesh.load_mesh(arrow_mesh_description);
        this.gizmo = this._ui_mesh.create_gizmo();
        this.gizmo.color_factor = GIZMO_COLOR_FACTOR.not_active;
        if (plane === 'x') {
            this.gizmo.rotation.z = -90 * (Math.PI / 180);
            this.gizmo.position.y += 0.25;
            this.gizmo.position.z += 0.25;
        }
        else if (plane === 'z') {
            this.gizmo.rotation.x = 90 * (Math.PI / 180);
            this.gizmo.position.y += 0.25;
            this.gizmo.position.x += 0.25;
        }
        else {
            this.gizmo.position.x += 0.25;
            this.gizmo.position.z += 0.25;
        }
        this.add_event_listeners();
        this._ui_mesh.draw_on_top = true;
    }
    add_event_listeners() {
        this.gizmo.pointer_enter_observable.add(this.on_pointer_over.bind(this));
        this.gizmo.drag_observable.add(this.on_drag.bind(this));
        this.gizmo.pointer_leave_observable.add(this.on_pointer_leave.bind(this));
    }
    on_pointer_over() {
        this.gizmo.color_factor = GIZMO_COLOR_FACTOR.active;
    }
    on_drag(_, event) {
        if (!this.transform_handling.get_world_transform) {
            const pos = this.transform_handling.position.get();
            if (this.plane === 'x') {
                pos.y += event.world_delta.y;
                pos.z += event.world_delta.z;
            }
            else if (this.plane === 'y') {
                pos.x += event.world_delta.x;
                pos.z += event.world_delta.z;
            }
            else {
                pos.x += event.world_delta.x;
                pos.y += event.world_delta.y;
            }
            this.transform_handling.position.set(pos);
            return;
        }
        if (this.use_global_transform) {
            this.handle_global_transform(event);
        }
        else {
            this.handle_local_transform(event);
        }
    }
    handle_global_transform(event) {
        const parent_transform = this.transform_handling.get_parent_world_transform ? this.transform_handling.get_parent_world_transform() : undefined;
        const position = parent_transform ? IMatrix4.transform_vector3(parent_transform, this.transform_handling.position.get()) : this.transform_handling.position.get();
        if (this.plane === 'x') {
            position.y += event.local_delta.y;
            position.z += event.local_delta.z;
        }
        else if (this.plane === 'y') {
            position.x += event.local_delta.x;
            position.z += event.local_delta.z;
        }
        else {
            position.x += event.local_delta.x;
            position.y += event.local_delta.y;
        }
        if (parent_transform) {
            const local_position = IMatrix4.transform_vector3(IMatrix4.inverse(parent_transform), position);
            this.transform_handling.position.set(local_position);
        }
        else {
            this.transform_handling.position.set(position);
        }
    }
    handle_local_transform(event) {
        assert(this.transform_handling.get_world_transform, 'Transform handling should contain world transform matrix getter');
        const parent_transform = this.transform_handling.get_parent_world_transform ? this.transform_handling.get_parent_world_transform() : undefined;
        const position = parent_transform ? IMatrix4.transform_vector3(parent_transform, this.transform_handling.position.get()) : this.transform_handling.position.get();
        const current_transform = this.transform_handling.get_world_transform();
        const rotation_matrix = IMatrix4.extractRotationMatrix(current_transform);
        let world_delta;
        switch (this.plane) {
            case 'x':
                world_delta = new IVector3(0, event.local_delta.y, event.local_delta.z);
                break;
            case 'y':
                world_delta = new IVector3(event.local_delta.x, 0, event.local_delta.z);
                break;
            case 'z':
                world_delta = new IVector3(event.local_delta.x, event.local_delta.y, 0);
                break;
        }
        const local_delta = IMatrix4.transform_vector3(rotation_matrix, world_delta);
        const new_position = IVector3.add(position, local_delta);
        if (parent_transform) {
            const local_position = IMatrix4.transform_vector3(IMatrix4.inverse(parent_transform), new_position);
            this.transform_handling.position.set(local_position);
        }
        else {
            this.transform_handling.position.set(new_position);
        }
    }
    on_pointer_leave() {
        this.gizmo.color_factor = GIZMO_COLOR_FACTOR.not_active;
    }
}
//# sourceMappingURL=MovePlane.js.map